[
  {
    "id": "design-001",
    "name": "Classic Celebration",
    "orientation": "portrait",
    "categories": [
      "Birthday"
    ],
    "tags": [
      "classic",
      "elegant"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "CC-001",
    "variants": [
      {
        "id": "design-001-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1.webp",
            "thumbUrl": "/images/1.webp"
          },
          "photo": {
            "slotBounds": {
              "x": 0.242,
              "y": 0.045,
              "width": 0.519,
              "height": 0.3657142857142857
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a day filled with joy and happiness!",
          "suggestions": [
            "May all your dreams come true!",
            "Celebrating you today and always!",
            "Here's to another year of wonderful memories!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-002",
    "name": "Birthday Wishes",
    "orientation": "portrait",
    "categories": [
      "Birthday"
    ],
    "tags": [
      "birthday",
      "festive",
      "personalizable"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "BW-002",
    "variants": [
      {
        "id": "design-002-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/2.webp",
            "thumbUrl": "/images/2.webp"
          },
          "textLayers": [
            {
              "id": "christmas_message",
              "label": "Holiday Message",
              "type": "string",
              "defaultValue": "Merry Christmas",
              "maxLength": 500,
              "maxFontSize": 2,
              "fontFamily": "Playfair Display, serif",
              "color": "#42443A",
              "textAlign": "center",
              "fontWeight": "bold",
              "bounds": {
                "x": 0.173,
                "y": 0.7864285714285715,
                "width": 0.655,
                "height": 0.07857142857142857
              },
              "defaultFontSize": 0.06106305803571429
            }
          ]
        },
        "inside": {
          "defaultMessage": "May your special day be filled with wonderful surprises!",
          "suggestions": [
            "Wishing you the happiest of birthdays!",
            "Another year older, another year wiser!",
            "Hope your day is as special as you are!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-003",
    "name": "Santa's Surprise",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "santa",
      "photo",
      "personalizable"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SS-003",
    "variants": [
      {
        "id": "design-003-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/3.webp",
            "thumbUrl": "/images/3.webp"
          },
          "photo": {
            "slotBounds": {
              "x": 0.315,
              "y": 0.28785714285714287,
              "width": 0.4,
              "height": 0.42857142857142855
            }
          },
          "textLayers": [
            {
              "id": "holiday_greeting",
              "label": "Holiday Greeting!",
              "type": "string",
              "defaultValue": "Happy Holidays!",
              "maxLength": 500,
              "defaultFontSize": 0.08838355654761905,
              "fontFamily": "Dancing Script, cursive",
              "color": "#ff0000",
              "textAlign": "center",
              "fontWeight": "lighter",
              "bounds": {
                "x": 0.142,
                "y": 0.09214285714285714,
                "width": 0.716,
                "height": 0.13714285714285715
              }
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-004",
    "name": "Watercolor Tree",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "watercolor",
      "minimalist"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "WT-004",
    "variants": [
      {
        "id": "design-004-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/4.webp",
            "thumbUrl": "/images/4.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "Yooooo!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        },
        "pages": "2pp"
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-005",
    "name": "Geometric Wishes",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "geometric",
      "modern",
      "contemporary"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "GW-005",
    "variants": [
      {
        "id": "design-005-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/5.webp",
            "thumbUrl": "/images/5.webp"
          },
          "textLayers": [
            {
              "id": "text_1764177849650",
              "label": "Name",
              "type": "string",
              "defaultValue": "Your name",
              "maxLength": 50,
              "bounds": {
                "x": 0.142,
                "y": 0.7735714285714286,
                "width": 0.291,
                "height": 0.07714285714285714
              },
              "defaultFontSize": 0.038392857142857145,
              "fontFamily": "DM Mono, monospace",
              "color": "#134A3B",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-006",
    "name": "Botanical Wreath",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "botanical",
      "evergreen",
      "elegant"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "BW-006",
    "variants": [
      {
        "id": "design-006-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/6.webp",
            "thumbUrl": "/images/6.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-007",
    "name": "Line Art Tree",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "minimalist",
      "line art",
      "contemporary"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "LAT-007",
    "variants": [
      {
        "id": "design-007-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/7.webp",
            "thumbUrl": "/images/7.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-008",
    "name": "Festive Ornaments",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "ornaments",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "FO-008",
    "variants": [
      {
        "id": "design-008-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/8.webp",
            "thumbUrl": "/images/8.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-009",
    "name": "Winter Wonderland",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "winter",
      "snow",
      "elegant"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "WW-009",
    "variants": [
      {
        "id": "design-009-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/9.webp",
            "thumbUrl": "/images/9.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-010",
    "name": "Classic Holiday",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "traditional",
      "classic"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "CH-010",
    "variants": [
      {
        "id": "design-010-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/10.webp",
            "thumbUrl": "/images/10.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-011",
    "name": "Joy & Cheer",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "joy",
      "cheerful"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "JC-011",
    "variants": [
      {
        "id": "design-011-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/11.webp",
            "thumbUrl": "/images/11.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-012",
    "name": "Peaceful Pines",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "nature",
      "pine",
      "peaceful"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PP-012",
    "variants": [
      {
        "id": "design-012-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/12.webp",
            "thumbUrl": "/images/12.webp"
          },
          "photo": {
            "slotBounds": {
              "x": 0.343,
              "y": 0.8135714285714286,
              "width": 0.325,
              "height": 0.13785714285714284
            }
          },
          "textLayers": []
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        },
        "pages": "2pp"
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-013",
    "name": "Merry & Bright",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "bright",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "MB-013",
    "variants": [
      {
        "id": "design-013-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/13.webp",
            "thumbUrl": "/images/13.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-014",
    "name": "Holiday Elegance",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "elegant",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "HE-014",
    "variants": [
      {
        "id": "design-014-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/14.webp",
            "thumbUrl": "/images/14.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-015",
    "name": "Festive Sparkle",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "sparkle",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "FS-015",
    "variants": [
      {
        "id": "design-015-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/15.webp",
            "thumbUrl": "/images/15.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-016",
    "name": "Season's Greetings",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "greetings",
      "classic"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SG-016",
    "variants": [
      {
        "id": "design-016-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/16.webp",
            "thumbUrl": "/images/16.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-017",
    "name": "Yuletide Joy",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "yuletide",
      "joy"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "YJ-017",
    "variants": [
      {
        "id": "design-017-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/17.webp",
            "thumbUrl": "/images/17.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-018",
    "name": "Cozy Christmas",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "cozy",
      "warm"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "CC-018",
    "variants": [
      {
        "id": "design-018-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/18.webp",
            "thumbUrl": "/images/18.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-019",
    "name": "Holiday Cheer",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "cheer",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "HC-019",
    "variants": [
      {
        "id": "design-019-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/19.webp",
            "thumbUrl": "/images/19.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-020",
    "name": "Snowy Celebration",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "snow",
      "celebration"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "SC-020",
    "variants": [
      {
        "id": "design-020-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/20.webp",
            "thumbUrl": "/images/20.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and happiness this holiday season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-021",
    "name": "Magical Moments",
    "orientation": "portrait",
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "magical",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "MM-021",
    "variants": [
      {
        "id": "design-021-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "static",
          "preview": {
            "frontUrl": "/images/21.webp",
            "thumbUrl": "/images/21.webp"
          }
        },
        "inside": {
          "defaultMessage": "Wishing you a season filled with joy and warmth!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful holiday season!",
            "Sending love and joy your way this Christmas!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "upload-own-l",
    "name": "Upload Your Own (Landscape)",
    "orientation": "landscape",
    "categories": [
      "Custom"
    ],
    "tags": [
      "custom",
      "photo",
      "upload"
    ],
    "artist": "Custom",
    "cardIdLabel": "CUSTOM",
    "variants": [
      {
        "id": "upload-own-5x7l",
        "label": "5x7 Landscape",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgMTQwMCAxMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxyZWN0IHdpZHRoPSIxNDAwIiBoZWlnaHQ9IjEwMDAiIGZpbGw9IiNmM2Y0ZjYiLz4KICA8dGV4dCB4PSI3MDAiIHk9IjQ1MCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjQ4IiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIFVwbG9hZCBZb3VyIE93bgogIDwvdGV4dD4KICA8dGV4dCB4PSI3MDAiIHk9IjUyMCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjMyIiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIEN1c3RvbSBQaG90bwogIDwvdGV4dD4KPC9zdmc+",
            "thumbUrl": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQyMCAzMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3Qgd2lkdGg9IjQyMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNmM2Y0ZjYiLz4KICA8dGV4dCB4PSIyMTAiIHk9IjEzNSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE4IiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIFVwbG9hZCBZb3VyIE93bgogIDwvdGV4dD4KICA8dGV4dCB4PSIyMTAiIHk9IjE2NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIEN1c3RvbSBQaG90bwogIDwvdGV4dD4KPC9zdmc+"
          },
          "photo": {
            "slotBounds": {
              "x": 0,
              "y": 0,
              "width": 1,
              "height": 1
            }
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [
            "Wishing you joy and happiness!",
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "upload-own-p",
    "name": "Upload Your Own (Portrait)",
    "orientation": "portrait",
    "categories": [
      "Custom"
    ],
    "tags": [
      "custom",
      "photo",
      "upload"
    ],
    "artist": "Custom",
    "cardIdLabel": "CUSTOM",
    "variants": [
      {
        "id": "upload-own-5x7p",
        "label": "5x7 Portrait",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxNDAwIiB2aWV3Qm94PSIwIDAgMTAwMCAxNDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxyZWN0IHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjE0MDAiIGZpbGw9IiNmM2Y0ZjYiLz4KICA8dGV4dCB4PSI1MDAiIHk9IjY1MCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjQ4IiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIFVwbG9hZCBZb3VyIE93bgogIDwvdGV4dD4KICA8dGV4dCB4PSI1MDAiIHk9IjcyMCIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjMyIiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIEN1c3RvbSBQaG90bwogIDwvdGV4dD4KPC9zdmc+",
            "thumbUrl": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjQyMCIgdmlld0JveD0iMCAwIDMwMCA0MjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSI0MjAiIGZpbGw9IiNmM2Y0ZjYiLz4KICA8dGV4dCB4PSIxNTAiIHk9IjE5NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE4IiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIFVwbG9hZCBZb3VyIE93bgogIDwvdGV4dD4KICA8dGV4dCB4PSIxNTAiIHk9IjIyNSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOWNhM2FmIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj4KICAgIEN1c3RvbSBQaG90bwogIDwvdGV4dD4KPC9zdmc+"
          },
          "photo": {
            "slotBounds": {
              "x": 0,
              "y": 0,
              "width": 1,
              "height": 1
            }
          }
        },
        "inside": {
          "defaultMessage": "",
          "suggestions": [
            "Wishing you joy and happiness!",
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ],
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ]
  },
  {
    "id": "design-1764156332234-flat-vector-illustration-full-bleed-no-shadows-lar-3-transparent",
    "name": "Birthday Polaroid Style",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "birthday-polaroid-style"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764156332234-3",
    "variants": [
      {
        "id": "design-1764156332234-flat-vector-illustration-full-bleed-no-shadows-lar-3-transparent-5x7p",
        "label": "Variation 3",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764156332234-flat-vector-illustration-full-bleed-no-shadows-lar-3-transparent.png",
            "thumbUrl": "/images/1764156332234-flat-vector-illustration-full-bleed-no-shadows-lar-3-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.20486607142857144,
              "y": 0.22054687499999998,
              "width": 0.59640625,
              "height": 0.580390625
            }
          },
          "textLayers": [
            {
              "id": "text_1764175380669",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Happy Birthday Sam!!",
              "maxLength": 50,
              "bounds": {
                "x": 0.308,
                "y": 0.8142857142857143,
                "width": 0.394,
                "height": 0.04642857142857143
              },
              "defaultFontSize": 0.03374255952380952,
              "fontFamily": "Shadows Into Light, cursive",
              "color": "#000000",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764156164245-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent",
    "name": "Birthday Balloon Cluster",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "birthday-balloon-cluster"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764156164245-4",
    "variants": [
      {
        "id": "design-1764156164245-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764156164245-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent.png",
            "thumbUrl": "/images/1764156164245-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.1289732142857143,
              "y": 0.075234375,
              "width": 0.7431696428571429,
              "height": 0.517890625
            }
          },
          "textLayers": [
            {
              "id": "text_1764178384895",
              "label": "Happy Birthday",
              "type": "string",
              "defaultValue": "Happy Birthday Name!",
              "maxLength": 50,
              "bounds": {
                "x": 0.135,
                "y": 0.7378571428571429,
                "width": 0.731,
                "height": 0.19642857142857142
              },
              "defaultFontSize": 0.07152622767857143,
              "fontFamily": "Quicksand, Arial, sans-serif",
              "color": "#0915be",
              "textAlign": "center",
              "fontWeight": "bold"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764155494933-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent",
    "name": "Blossom Wreath Frame",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday",
      "Thank You"
    ],
    "tags": [
      "floral",
      "wreath",
      "elegant",
      "botanical"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764155494933-1",
    "variants": [
      {
        "id": "design-1764155494933-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent-5x7p",
        "label": "Variation 1",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764155494933-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent.png",
            "thumbUrl": "/images/1764155494933-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.20933035714285714,
              "y": 0.288515625,
              "width": 0.58078125,
              "height": 0.41359375
            }
          },
          "textLayers": [
            {
              "id": "text_top_greeting",
              "label": "Top Greeting",
              "type": "string",
              "defaultValue": "Happy Birthday",
              "maxLength": 30,
              "bounds": {
                "x": 0.1,
                "y": 0.08,
                "width": 0.8,
                "height": 0.12
              },
              "defaultFontSize": 0.09303385416666667,
              "fontFamily": "Great Vibes, cursive",
              "color": "#D4857F",
              "textAlign": "center",
              "fontWeight": "normal"
            },
            {
              "id": "text_bottom_name",
              "label": "Name",
              "type": "string",
              "defaultValue": "Sarah!",
              "maxLength": 25,
              "bounds": {
                "x": 0.15,
                "y": 0.82,
                "width": 0.7,
                "height": 0.1
              },
              "defaultFontSize": 0.08257068452380953,
              "fontFamily": "Great Vibes, cursive",
              "color": "#D4857F",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you a beautiful day filled with joy!",
          "suggestions": [
            "Thank you for being wonderful!",
            "Sending love and warm wishes!",
            "Hope your day is as lovely as you are!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764156249202-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent",
    "name": "Holly Wreath Frame",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas",
      "wreath",
      "holly",
      "festive"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764156249202-1",
    "variants": [
      {
        "id": "design-1764156249202-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent-5x7p",
        "label": "Variation 1",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764156249202-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent.png",
            "thumbUrl": "/images/1764156249202-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.25620535714285714,
              "y": 0.32640625,
              "width": 0.4898214285714285,
              "height": 0.353046875
            }
          },
          "textLayers": [
            {
              "id": "text_christmas_greeting",
              "label": "Christmas Greeting",
              "type": "string",
              "defaultValue": "Merry Christmas",
              "maxLength": 30,
              "bounds": {
                "x": 0.224,
                "y": 0.09428571428571429,
                "width": 0.578,
                "height": 0.060714285714285714
              },
              "defaultFontSize": 0.04885602678571429,
              "fontFamily": "Playfair Display, serif",
              "color": "#1E4D2B",
              "textAlign": "center",
              "fontWeight": "bold"
            },
            {
              "id": "text_christmas_name",
              "label": "To/From",
              "type": "string",
              "defaultValue": "The Smith Family",
              "maxLength": 35,
              "bounds": {
                "x": 0.212,
                "y": 0.87,
                "width": 0.576,
                "height": 0.08214285714285714
              },
              "defaultFontSize": 0.05176246279761905,
              "fontFamily": "Playfair Display, serif",
              "color": "#B22222",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you peace, joy, and love this Christmas season!",
          "suggestions": [
            "May your holidays be merry and bright!",
            "Warmest wishes for a wonderful Christmas!",
            "Sending love and blessings this holiday season!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764156235594-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Snowman Face Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Christmas"
    ],
    "tags": [
      "snowman-face-cutout"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764156235594-4",
    "variants": [
      {
        "id": "design-1764156235594-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764156235594-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764156235594-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.2026339285714286,
              "y": 0.12093749999999999,
              "width": 0.5869196428571429,
              "height": 0.42023437500000005
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764164457449-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent",
    "name": "Astronaut Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "astronaut-cutout",
      "kids"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764164457449-3",
    "variants": [
      {
        "id": "design-1764164457449-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent-5x7p",
        "label": "Variation 3",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764164457449-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png",
            "thumbUrl": "/images/1764164457449-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.30698660714285714,
              "y": 0.233828125,
              "width": 0.3877008928571428,
              "height": 0.279609375
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764164772779-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent",
    "name": "Superhero Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "superhero-cutout",
      "kids"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764164772779-3",
    "variants": [
      {
        "id": "design-1764164772779-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent-5x7p",
        "label": "Variation 3",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764164772779-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png",
            "thumbUrl": "/images/1764164772779-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.2550892857142857,
              "y": 0.2396875,
              "width": 0.3346875,
              "height": 0.2440625
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764164692257-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Mermaid Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "mermaid",
      "underwater",
      "kids",
      "fantasy"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764164692257-4",
    "variants": [
      {
        "id": "design-1764164692257-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764164692257-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764164692257-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.3371205357142857,
              "y": 0.24984374999999998,
              "width": 0.30734375,
              "height": 0.2190625
            }
          },
          "textLayers": [
            {
              "id": "text_mermaid_greeting",
              "label": "Birthday Message",
              "type": "string",
              "defaultValue": "Happy Birthday Emma!",
              "maxLength": 30,
              "bounds": {
                "x": 0.05,
                "y": 0.02,
                "width": 0.9,
                "height": 0.12
              },
              "defaultFontSize": 0.065,
              "fontFamily": "Bubblegum Sans, cursive",
              "color": "#FFFFFF",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Have a splashing good birthday!",
          "suggestions": [
            "You're fin-tastic!",
            "Wishing you an ocean of fun!",
            "Make a splash on your special day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764156182690-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent",
    "name": "Santa Face Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Christmas"
    ],
    "tags": [
      "santa-face-cutout"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764156182690-1",
    "variants": [
      {
        "id": "design-1764156182690-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent-5x7p",
        "label": "Variation 1",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764156182690-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent.png",
            "thumbUrl": "/images/1764156182690-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.27685267857142853,
              "y": 0.2553125,
              "width": 0.4340178571428571,
              "height": 0.2878125
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764156202968-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent",
    "name": "Christmas Ornament Photo",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Christmas"
    ],
    "tags": [
      "christmas-ornament-photo"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764156202968-4",
    "variants": [
      {
        "id": "design-1764156202968-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764156202968-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent.png",
            "thumbUrl": "/images/1764156202968-flat-vector-illustration-full-bleed-no-shadows-lar-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.1445982142857143,
              "y": 0.242421875,
              "width": 0.7007589285714286,
              "height": 0.508125
            }
          },
          "textLayers": [
            {
              "id": "text_1764178220648",
              "label": "Happy Holidays!",
              "type": "string",
              "defaultValue": "Happy Holidays!",
              "maxLength": 50,
              "bounds": {
                "x": 0.166,
                "y": 0.8328571428571429,
                "width": 0.669,
                "height": 0.11428571428571428
              },
              "defaultFontSize": 0.05,
              "fontFamily": "Pacifico, cursive",
              "color": "#562521",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764164423763-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Owl Graduation Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Graduation"
    ],
    "tags": [
      "owl",
      "graduation",
      "celebration",
      "academic"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764164423763-4",
    "variants": [
      {
        "id": "design-1764164423763-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764164423763-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764164423763-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.29247767857142853,
              "y": 0.332265625,
              "width": 0.420625,
              "height": 0.29679687499999996
            }
          },
          "textLayers": [
            {
              "id": "text_grad_congrats",
              "label": "Congratulations",
              "type": "string",
              "defaultValue": "Congratulations!",
              "maxLength": 25,
              "bounds": {
                "x": 0.08,
                "y": 0.02,
                "width": 0.84,
                "height": 0.12
              },
              "defaultFontSize": 0.06,
              "fontFamily": "Luckiest Guy, cursive",
              "color": "#C41E3A",
              "textAlign": "center",
              "fontWeight": "normal"
            },
            {
              "id": "text_grad_name",
              "label": "Graduate Name",
              "type": "string",
              "defaultValue": "Class of 2025!",
              "maxLength": 30,
              "bounds": {
                "x": 0.1,
                "y": 0.88,
                "width": 0.8,
                "height": 0.1
              },
              "defaultFontSize": 0.045,
              "fontFamily": "Fredoka, sans-serif",
              "color": "#8B4513",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "You did it! So proud of you!",
          "suggestions": [
            "The future is yours - go get it!",
            "Your hard work has paid off!",
            "Wishing you success in all your adventures!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764164877165-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Princess Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "princess",
      "fairy tale",
      "kids",
      "magical"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764164877165-4",
    "variants": [
      {
        "id": "design-1764164877165-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764164877165-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764164877165-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.25676339285714284,
              "y": 0.22328125,
              "width": 0.48703125,
              "height": 0.34875
            }
          },
          "textLayers": [
            {
              "id": "text_princess_birthday",
              "label": "Birthday Message",
              "type": "string",
              "defaultValue": "Happy Birthday Princess!",
              "maxLength": 35,
              "bounds": {
                "x": 0.05,
                "y": 0.01,
                "width": 0.9,
                "height": 0.1
              },
              "defaultFontSize": 0.055,
              "fontFamily": "Lilita One, cursive",
              "color": "#D4488E",
              "textAlign": "center",
              "fontWeight": "normal"
            },
            {
              "id": "text_princess_name",
              "label": "Name",
              "type": "string",
              "defaultValue": "Sofia",
              "maxLength": 20,
              "bounds": {
                "x": 0.2,
                "y": 0.9,
                "width": 0.6,
                "height": 0.08
              },
              "defaultFontSize": 0.05,
              "fontFamily": "Pacifico, cursive",
              "color": "#9B59B6",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you a magical day!",
          "suggestions": [
            "Have a royally wonderful birthday!",
            "May all your fairy tale dreams come true!",
            "You're a real-life princess!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764164846462-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Pirate Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "pirate",
      "adventure",
      "kids",
      "treasure"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764164846462-4",
    "variants": [
      {
        "id": "design-1764164846462-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764164846462-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764164846462-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.3332142857142857,
              "y": 0.22484375,
              "width": 0.3218526785714285,
              "height": 0.220234375
            }
          },
          "textLayers": [
            {
              "id": "text_pirate_ahoy",
              "label": "Pirate Greeting",
              "type": "string",
              "defaultValue": "Ahoy Captain Jack!",
              "maxLength": 30,
              "bounds": {
                "x": 0.05,
                "y": 0.01,
                "width": 0.9,
                "height": 0.1
              },
              "defaultFontSize": 0.06,
              "fontFamily": "Bangers, cursive",
              "color": "#FFD700",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Arrr! Have a treasure-filled birthday!",
          "suggestions": [
            "X marks the spot for an awesome birthday!",
            "Sail into another year of adventure!",
            "You're worth more than gold, matey!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165171012-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent",
    "name": "Turkey Thanksgiving Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Thanksgiving"
    ],
    "tags": [
      "turkey-thanksgiving-cutout"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165171012-3",
    "variants": [
      {
        "id": "design-1764165171012-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent-5x7p",
        "label": "Variation 3",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165171012-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png",
            "thumbUrl": "/images/1764165171012-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.25174107142857144,
              "y": 0.3475,
              "width": 0.4970758928571428,
              "height": 0.345234375
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165191036-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent",
    "name": "Witch Halloween Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Halloween"
    ],
    "tags": [
      "witch-halloween-cutout"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165191036-3",
    "variants": [
      {
        "id": "design-1764165191036-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent-5x7p",
        "label": "Variation 3",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165191036-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png",
            "thumbUrl": "/images/1764165191036-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.338,
              "y": 0.30857142857142855,
              "width": 0.316,
              "height": 0.32285714285714284
            }
          },
          "textLayers": [
            {
              "id": "text_halloween_message",
              "label": "Halloween Message",
              "type": "string",
              "defaultValue": "Happy Halloween!",
              "maxLength": 40,
              "bounds": {
                "x": 0.16,
                "y": 0.8392857142857143,
                "width": 0.68,
                "height": 0.1
              },
              "defaultFontSize": 0.06338820684523809,
              "fontFamily": "Creepster, cursive",
              "color": "#FFB347",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Have a spooktacular time!",
          "suggestions": [
            "Wishing you a frightfully fun Halloween!",
            "Have a boo-tiful Halloween!",
            "Hope your Halloween is full of treats!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165214819-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Vampire Halloween Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Halloween"
    ],
    "tags": [
      "vampire-halloween-cutout"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165214819-4",
    "variants": [
      {
        "id": "design-1764165214819-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165214819-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764165214819-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.28801339285714284,
              "y": 0.2834375,
              "width": 0.4183928571428571,
              "height": 0.32062500000000005
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165474982-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent",
    "name": "Disco Ball Frame",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "disco-ball-frame",
      "party"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165474982-1",
    "variants": [
      {
        "id": "design-1764165474982-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent-5x7p",
        "label": "Variation 1",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165474982-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent.png",
            "thumbUrl": "/images/1764165474982-flat-vector-illustration-full-bleed-no-shadows-lar-1-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.1992857142857143,
              "y": 0.294765625,
              "width": 0.6070089285714286,
              "height": 0.43390625000000005
            }
          },
          "textLayers": [
            {
              "id": "text_1764178527149",
              "label": "Text top",
              "type": "string",
              "defaultValue": "Happy Birthday Name!!",
              "maxLength": 50,
              "bounds": {
                "x": 0.117,
                "y": 0.07571428571428572,
                "width": 0.766,
                "height": 0.145
              },
              "defaultFontSize": 0.07,
              "fontFamily": "Bangers, cursive",
              "color": "#81d83b",
              "textAlign": "center",
              "fontWeight": "normal"
            },
            {
              "id": "text_1764178596512",
              "label": "Bottom text",
              "type": "string",
              "defaultValue": "Party like you're 21!",
              "maxLength": 50,
              "bounds": {
                "x": 0.065,
                "y": 0.8035714285714286,
                "width": 0.87,
                "height": 0.12642857142857142
              },
              "defaultFontSize": 0.05,
              "fontFamily": "Bangers, cursive",
              "color": "#81d83b",
              "textAlign": "center",
              "fontWeight": "normal"
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165523732-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent",
    "name": "Clown Birthday Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "clown-birthday-cutout",
      "kids"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165523732-4",
    "variants": [
      {
        "id": "design-1764165523732-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent-5x7p",
        "label": "Variation 4",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165523732-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png",
            "thumbUrl": "/images/1764165523732-flat-vector-illustration-full-bleed-no-shadows-ill-4-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.07651785714285714,
              "y": 0.17679687500000002,
              "width": 0.8285491071428571,
              "height": 0.37609375
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165591181-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent",
    "name": "Robot Birthday Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "robot-birthday-cutout",
      "kids"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165591181-1",
    "variants": [
      {
        "id": "design-1764165591181-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent-5x7p",
        "label": "Variation 1",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165591181-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent.png",
            "thumbUrl": "/images/1764165591181-flat-vector-illustration-full-bleed-no-shadows-ill-1-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.3254017857142857,
              "y": 0.272890625,
              "width": 0.3514285714285714,
              "height": 0.26046875
            }
          }
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  },
  {
    "id": "design-1764165646222-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent",
    "name": "Race Car Driver Cutout",
    "orientation": "portrait",
    "supportedPaperSizes": [
      "5x7",
      "A5",
      "A6",
      "4x6"
    ],
    "categories": [
      "Birthday"
    ],
    "tags": [
      "race-car-driver-cutout",
      "kids"
    ],
    "artist": "Studio Giftie",
    "cardIdLabel": "PUB-1764165646222-3",
    "variants": [
      {
        "id": "design-1764165646222-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent-5x7p",
        "label": "Variation 3",
        "front": {
          "type": "photo",
          "preview": {
            "frontUrl": "/images/1764165646222-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png",
            "thumbUrl": "/images/1764165646222-flat-vector-illustration-full-bleed-no-shadows-ill-3-transparent.png"
          },
          "photo": {
            "slotBounds": {
              "x": 0.29247767857142853,
              "y": 0.24984374999999998,
              "width": 0.41671875,
              "height": 0.30304687500000005
            }
          },
          "textLayers": [
            {
              "id": "text_1764327540770",
              "label": "New Text",
              "type": "string",
              "defaultValue": "Happy Birthday Sam!!",
              "maxLength": 50,
              "bounds": {
                "x": 0.248,
                "y": 0.039285714285714285,
                "width": 0.505,
                "height": 0.07642857142857143
              },
              "fontSize": 0.0229,
              "fontFamily": "Righteous, cursive",
              "color": "#e22b29",
              "textAlign": "center",
              "fontWeight": "normal",
              "defaultFontSize": 0.034905133928571426
            }
          ]
        },
        "inside": {
          "defaultMessage": "Wishing you joy and happiness!",
          "suggestions": [
            "Thinking of you today!",
            "Sending love and warm wishes!",
            "Hope this brings a smile to your day!"
          ],
          "maxChars": 600
        }
      }
    ]
  }
]
